import React, { useEffect, useMemo, useState } from 'react'
import { Box, CircularProgress, Tab, Tabs } from '@mui/material'

import { useNavigate, useLocation, Outlet } from 'react-router-dom'
import useIsAdmin from '../hooks/useIsAdmin'
import PageTitle from '../common/PageTitle'
import useCompanyConfig from '../hooks/api/useCompanyConfig'
import TabsOrMobileDropdown from '../common/TabsOrMobileDropdown'
import useIsMobile from '../hooks/useIsMobile'
import { grey } from '@mui/material/colors'

const Settings = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const subPath = location.pathname.split('/settings')[1]

  const { companyConfig, isLoading } = useCompanyConfig()

  const { isAdmin } = useIsAdmin()

  const tabs = useMemo(() => {
    const paths = [
      { label: 'Name & Logo', path: '/logo' },
      { label: 'Users', path: '/users' },
      { label: 'Business Type', path: '/business-type' },
      { label: 'Dropdowns', path: '/dropdowns' },
      { label: 'Custom Fields', path: '/custom-fields' },
      { label: 'Contacts', path: '/contacts' },
      // { label: 'Actions', path: '/actions' },
      { label: 'Products', path: '/products' },
      { label: 'Pipelines', path: '/pipelines' },
      { label: 'Lead Import', path: '/lead-import' },
    ]

    if (isLoading) return null

    // if (!companyConfig.hasCompletedBulkImport)
    paths.push({ label: 'Account Import', path: '/account-import' })

    return paths
  }, [isLoading, companyConfig])

  const [tab, setTab] = useState(null)

  useEffect(() => {
    if (!tabs) return
    setTab(subPath && tabs ? tabs.map((t) => t.path).indexOf(subPath) : null)
  }, [tabs, subPath])

  useEffect(() => {
    if (isLoading || !tabs) return
    if (!isAdmin) return navigate('/')
    if (!subPath) return navigate('/settings/logo')
  }, [isAdmin, subPath, isLoading, tabs])

  const isMobile = useIsMobile()

  if (isLoading || !tabs || tab === null) return <CircularProgress />

  return (
    <Box>
      <PageTitle>Settings</PageTitle>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mb: 3,
          pb: 1,
          mx: -3,
          px: 3,
          // borderBottom: isMobile ? `1px solid ${grey[600]}` : null,
        }}
      >
        <TabsOrMobileDropdown
          tabs={tabs}
          setTab={(value) => {
            setTab(value)
            const path = `/settings${tabs[value].path}`
            navigate(path)
          }}
          tab={tab}
        ></TabsOrMobileDropdown>

        {/* <Tabs
          onChange={(_e, value) => {
            setTab(value)
            const path = `/settings${tabs[value].path}`
            navigate(path)
          }}
          value={tab}
        >
          {tabs.map((t, i) => {
            return <Tab key={i} label={t.label}></Tab>
          })}
        </Tabs> */}
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        {tabs?.[tab].path === '/dropdowns' ? (
          <Outlet />
        ) : (
          <Box sx={{ width: '800px' }}>
            <Outlet />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default Settings
